const TAG_PREFIX = "vt-usertag-";
const TAG_PREFIX_LEN = TAG_PREFIX.length;

/**
 * 提取全局用户标签信息
 * @return {{[K: string]: string}} [description]
 */
export function userTag(): { [K: string]: string } {
    const attrs = document.body.attributes;

    return Array.from(attrs).reduce((m, att) => {
        if (att.name?.startsWith(TAG_PREFIX)) {
            m[att.name.substr(TAG_PREFIX_LEN)] = att.value;
        }

        return m;
    }, {});
}
